import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';

const NotFoundPage: React.FC = () => {
  return (
    <div className="container-custom py-16 text-center">
      <div className="max-w-md mx-auto">
        <h1 className="text-6xl font-bold text-snudefryd-blue mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">Side ikke fundet</h2>
        <p className="text-gray-600 mb-8">
          Beklager, men siden du leder efter findes ikke. Den kan være flyttet, slettet eller har aldrig eksisteret.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/">
            <Button variant="primary">Gå til forsiden</Button>
          </Link>
          <Link to="/blog">
            <Button variant="secondary">Læs vores blog</Button>
          </Link>
        </div>
        
        <div className="mt-12">
          <img 
            src="https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
            alt="Hund der ser forvirret ud" 
            className="w-full h-64 object-cover rounded-lg shadow-md"
          />
          <p className="text-sm text-gray-500 mt-4">
            Selv vores hunde kan ikke finde denne side!
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage; 